import { supabase } from '@/shared/api/supabase';
import { throwAsSupabaseError } from '@/shared/lib';
import type { NaverLocalSearchResponse } from '@/shared/types/naver.types';

const naverApi = {
	searchPlace: async (
		query: string,
		display: number = 5,
		sort: 'random' | 'comment' = 'comment',
	): Promise<NaverLocalSearchResponse> => {
		const params = new URLSearchParams({
			query,
			display: String(display),
			sort,
		});
		const { data, error } =
			await supabase.functions.invoke<NaverLocalSearchResponse>(
				`naver-search?${params}`,
				{
					method: 'GET',
				},
			);

		if (error) throwAsSupabaseError(error);

		return (
			data || { lastBuildDate: '', total: 0, start: 0, display: 0, items: [] }
		);
	},
};

export default naverApi;
